import styled from 'styled-components';
import { useState, useEffect } from 'react';
import GetElement, { EnrichedContent } from 'src/components/getElement';
import SecondPageBlockMessageBox from 'src/modules/community/singlePost/components/secondPageBlockMessageBox';
import { PostBody } from 'src/modules/community/singlePost/components/post';
import { useSelector } from 'src/store/store';
import { getLocalStorageItem, Key } from 'src/utils/localStorage';
export default function BlockedPost({
  postEnrichedBody
}: {
  postEnrichedBody: EnrichedContent;
}) {
  return <BlockMessageContainer data-sentry-element="BlockMessageContainer" data-sentry-component="BlockedPost" data-sentry-source-file="blockedPost.tsx">
      <PostBody className="js-post-body" data-sentry-element="PostBody" data-sentry-source-file="blockedPost.tsx">
        <GetElement enrichedContent={postEnrichedBody?.slice(0, 3)} data-sentry-element="GetElement" data-sentry-source-file="blockedPost.tsx" />
      </PostBody>
      <SecondPageBlockMessageBox data-sentry-element="SecondPageBlockMessageBox" data-sentry-source-file="blockedPost.tsx" />
    </BlockMessageContainer>;
}
const BlockMessageContainer = styled.div`
  position: relative;

  ${PostBody} {
    height: 85px;
    margin-bottom: 0;
  }
`;
export function useIsPostBlocked() {
  const isSecondPageBlockMsgBoxVisible = useSelector(({
    pages
  }) => pages.singlePost.isSecondPageBlockMsgBoxVisible);
  const [isSecondBlockVisible, setIsSecondBlockVisible] = useState(isSecondPageBlockMsgBoxVisible);
  useEffect(() => {
    setIsSecondBlockVisible(Boolean(getLocalStorageItem(Key.secondPageBlock)) || isSecondPageBlockMsgBoxVisible);
  }, [isSecondPageBlockMsgBoxVisible]);
  return isSecondBlockVisible;
}